var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShortcutCancelStay(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.875 42V8.25H4.125V42H43.875ZM45.375 43.5H2.625V6.75H45.375V43.5Z",
    fill: "#0C2487"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.375 15L2.625 15L2.625 13.5L45.375 13.5L45.375 15Z",
    fill: "#0C2487"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.375 20.25H10.125V25.5H15.375V20.25ZM8.625 18.75V27H16.875V18.75H8.625Z",
    fill: "#0C2487"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.9384 22.8741L20.0938 20.0294L21.1544 18.9688L23.9991 21.8134L26.8438 18.9688L27.9044 20.0294L25.0597 22.8741L27.9044 25.7187L26.8438 26.7794L23.9991 23.9347L21.1544 26.7794L20.0938 25.7187L22.9384 22.8741Z",
    fill: "#0C2487"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.875 20.25H32.625V25.5H37.875V20.25ZM31.125 18.75V27H39.375V18.75H31.125Z",
    fill: "#0C2487"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.375 31.5H10.125V36.75H15.375V31.5ZM8.625 30V38.25H16.875V30H8.625Z",
    fill: "#0C2487"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.625 31.5H21.375V36.75H26.625V31.5ZM19.875 30V38.25H28.125V30H19.875Z",
    fill: "#0C2487"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.875 31.5H32.625V36.75H37.875V31.5ZM31.125 30V38.25H39.375V30H31.125Z",
    fill: "#0C2487"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.875 10.5L10.875 4.5L12.375 4.5L12.375 10.5L10.875 10.5Z",
    fill: "#0C2487"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.125 10.5L19.125 4.5L20.625 4.5L20.625 10.5L19.125 10.5Z",
    fill: "#0C2487"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.375 10.5L27.375 4.5L28.875 4.5L28.875 10.5L27.375 10.5Z",
    fill: "#0C2487"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.625 10.5L35.625 4.5L37.125 4.5L37.125 10.5L35.625 10.5Z",
    fill: "#0C2487"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShortcutCancelStay);
export default __webpack_public_path__ + "static/media/shortcut_cancelStay.7bc7ba223bfd3efd189aa3de681b7e1c.svg";
export { ForwardRef as ReactComponent };